import _groupBy from 'lodash/groupBy';
import _isNil from 'lodash/isNil';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import MapComponent from '@Components/MapComponents/MapLibre/MapLibreMapComponent';
import {
    LayerType,
    getLayerId,
} from '@Components/MapComponents/MapLibre/Utils';
import EntitiesApi from '@Data/entities/Api';
import { IEntity } from '@Data/entities/Interfaces';
import { selectedEntityState } from '@Data/entities/Reducer';
import { qualityControlGeoserverDataState } from '@Data/qualityControl/Reducer';
import { viewStateState } from '@Data/workbenches/Reducer';

interface IQualityControlMapProps {
    isLoading: boolean;
}

export const QualityControlMap = (props: IQualityControlMapProps) => {
    const sourceData = useSelector(qualityControlGeoserverDataState);
    const selectedEntity: IEntity = useSelector(selectedEntityState);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [baseLayerId, setBaseLayerId] = useState<string>('');
    const viewState = useSelector(viewStateState);

    useEffect(() => {
        setBaseLayerId(Math.random().toString(32));
    }, [sourceData]);

    const handleFeatureClick = (features) => {
        const pointFeatures = features.filter(
            (f) => f.layer.id === getLayerId(baseLayerId, LayerType.POINT)
        );
        if (pointFeatures.length > 0) {
            handleSelectEntityVersion(
                pointFeatures[0].properties.entity_version_id
            );
        }
    };

    const handleSelectEntityVersion = (entityVersionId: string) => {
        setIsLoading(true);
        EntitiesApi.getEntityVersionDetails(
            entityVersionId,
            (entityVersion) => {
                setIsLoading(false);
                EntitiesApi.setSelectedEntityVersion(entityVersion);
            }
        );
    };

    const mapKey = useMemo(() => {
        return Math.random().toString(32);
    }, []);

    const loading = isLoading || props.isLoading;

    return (
        <MapComponent
            sourceData={sourceData}
            selectedEntity={selectedEntity}
            onFeatureClick={handleFeatureClick}
            isPopupOpen={false}
            isLoading={loading}
            baseLayerId={baseLayerId}
            flyToEntityId={selectedEntity?.entity_version_id}
            key={mapKey}
            initialViewState={viewState}
        />
    );
};
